import { useCallback } from 'react'
import { useRealtimeEvents, type RealtimeEvent } from '@intellimon/shared/hooks'
import { tenantTokens } from '@intellimon/shared/utils'
import { toast } from '@intellimon/shared/components'
import { useAuthStore } from '../stores/authStore'

export function useRealtimeUpdates() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)

  const onEvent = useCallback((event: RealtimeEvent) => {
    // Show toast for critical notifications
    if (event.event === 'notification' && event.data.level === 'critical') {
      toast.error(event.data.title as string)
    }
  }, [])

  return useRealtimeEvents({
    getAccessToken: tenantTokens.getAccessToken,
    onEvent,
    enabled: isAuthenticated,
  })
}
